import { render, staticRenderFns } from "./ModalBibliotecaPrompts.vue?vue&type=template&id=8be41a76&scoped=true"
import script from "./ModalBibliotecaPrompts.vue?vue&type=script&lang=js"
export * from "./ModalBibliotecaPrompts.vue?vue&type=script&lang=js"
import style0 from "./ModalBibliotecaPrompts.vue?vue&type=style&index=0&id=8be41a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be41a76",
  null
  
)

export default component.exports